(() => {
  'use strict';

  if (window.tayumazTowelGiftLoaded) return;
  window.tayumazTowelGiftLoaded = true;

  const CONFIG = {
    variantId: '43566807449763',

    // Shopifyのカート金額は、日本円でも100倍の値で返ります。
    threshold: 10000 * 100,

    image:
      'https://cdn.shopify.com/s/files/1/0558/7900/8419/files/20230927-7.png?v=1695798416',

    productText: '1万円以上購入でプレゼント',

    belowText: '1万円以上購入したらタオルプレゼント',

    qualifiedText:
      'カート追加ありがとうございます。1万円以上選択されているため、タオルも一緒にお送りします。',

    errorText:
      'プレゼント用タオルを確認できませんでした。ページを再読み込みしてください。',

    unavailableText:
      'プレゼント用タオルを追加できませんでした。売り切れ等の可能性があります。'
  };

  const root = window.Shopify?.routes?.root || '/';
  const cartPath = `${root}cart`;

  // このコード自身の通信には、元のfetchを使用します。
  const originalFetch = window.fetch.bind(window);

  let busy = false;
  let pending = false;
  let redirecting = false;
  let timer;
  let lastCart = null;

  function isCartPage() {
    return location.pathname.replace(/\/$/, '') === cartPath;
  }

  function isProductPage() {
    return /\/products\/[^/]+\/?$/.test(location.pathname);
  }

  function isTowel(item) {
    return String(item.variant_id) === CONFIG.variantId;
  }

  function qualifyingTotal(cart) {
    return cart.items.reduce((sum, item) => {
      return isTowel(item)
        ? sum
        : sum + item.final_line_price;
    }, 0);
  }

  function qualifies(cart) {
    return cart.currency === 'JPY' &&
      qualifyingTotal(cart) >= CONFIG.threshold;
  }

  async function request(path, body) {
    const options = {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    };

    if (body !== undefined) {
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(body);
    }

    const response = await originalFetch(`${root}${path}`, options);
    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        data.description || data.message || CONFIG.errorText
      );
    }

    return data;
  }

  function navigateToCart() {
    if (redirecting) return;

    redirecting = true;
    location.assign(cartPath);
  }

  function createNotice(kind) {
    const box = document.createElement('div');
    box.className = 'tayumaz-towel-notice';
    box.dataset.towelNotice = kind;

    const image = document.createElement('img');
    image.src = CONFIG.image;
    image.alt = 'プレゼント用フェイスタオル';
    image.width = 100;
    image.height = 100;
    image.loading = 'lazy';

    const text = document.createElement('p');
    text.dataset.towelText = '';
    text.setAttribute('aria-live', 'polite');

    box.append(image, text);
    return box;
  }

  function renderNotices() {
    if (isProductPage()) {
      document.querySelectorAll(
        'product-info form[action*="/cart/add"]'
      ).forEach((form) => {
        const button = form.querySelector('.product-form__submit');
        if (!button) return;

        let notice = form.querySelector(
          '[data-towel-notice="product"]'
        );

        if (!notice) {
          notice = createNotice('product');

          const buttons = button.closest('.product-form__buttons');
          if (buttons && form.contains(buttons)) {
            buttons.before(notice);
          } else {
            button.before(notice);
          }
        }

        const text = notice.querySelector('[data-towel-text]');
        if (text.textContent !== CONFIG.productText) {
          text.textContent = CONFIG.productText;
        }
      });
    }

    if (!isCartPage()) return;

    const anchor =
      document.querySelector('#main-cart-footer') ||
      document.querySelector('#main-cart-items');

    if (!anchor) return;

    let notice = document.querySelector(
      '[data-towel-notice="cart"]'
    );

    if (!notice) {
      notice = createNotice('cart');
      anchor.before(notice);
    }

    if (!lastCart) return;

    const towelQuantity = lastCart.items
      .filter(isTowel)
      .reduce((sum, item) => sum + item.quantity, 0);

    const text = notice.querySelector('[data-towel-text]');

    const message =
      qualifies(lastCart) && towelQuantity === 1
        ? CONFIG.qualifiedText
        : qualifies(lastCart)
          ? CONFIG.unavailableText
          : CONFIG.belowText;

    if (text.textContent !== message) {
      text.textContent = message;
    }
  }

  function showError(message) {
    let error = document.querySelector('#tayumaz-towel-error');

    if (!error) {
      error = document.createElement('p');
      error.id = 'tayumaz-towel-error';
      error.className = 'tayumaz-towel-error';
      error.setAttribute('role', 'alert');

      const target =
        document.querySelector('[data-towel-notice]') ||
        document.querySelector('main');

      if (target) target.append(error);
    }

    if (error.textContent !== message) {
      error.textContent = message;
    }
  }

  async function syncGift() {
    if (busy || redirecting) {
      pending = true;
      return;
    }

    busy = true;
    let changed = false;

    try {
      let cart = await request('cart.js');

      // 他通貨ではこの日本円キャンペーンを処理しません。
      if (cart.currency !== 'JPY') {
        lastCart = cart;
        renderNotices();
        return;
      }

      const towels = cart.items.filter(isTowel);
      const eligible = qualifies(cart);

      if (eligible && towels.length === 0) {
        await request('cart/add.js', {
          items: [{
            id: Number(CONFIG.variantId),
            quantity: 1,
            properties: {
              _tayumaz_gift: 'towel-10000'
            }
          }]
        });

        changed = true;
      } else {
        // 同じタオルが複数の行に分かれていても、合計1点にします。
        const updates = {};

        towels.forEach((item, index) => {
          const desiredQuantity = eligible && index === 0 ? 1 : 0;

          if (item.quantity !== desiredQuantity) {
            updates[item.key] = desiredQuantity;
          }
        });

        if (Object.keys(updates).length > 0) {
          await request('cart/update.js', { updates });
          changed = true;
        }
      }

      if (changed) {
        cart = await request('cart.js');
      }

      lastCart = cart;
      renderNotices();

      // 更新された明細と金額を、テーマ標準の表示で読み直します。
      if (changed && isCartPage()) {
        navigateToCart();
      }
    } catch (error) {
      console.error('[TAYUMAZ towel gift]', error);
      showError(CONFIG.errorText);
    } finally {
      busy = false;

      if (pending && !redirecting) {
        pending = false;
        scheduleSync();
      }
    }
  }

  function scheduleSync() {
    clearTimeout(timer);
    timer = setTimeout(syncGift, 250);
  }

  function isCartMutation(input, options) {
    try {
      const value =
        input instanceof Request ? input.url : String(input);

      const url = new URL(value, location.href);
      const method = (
        options?.method ||
        (input instanceof Request ? input.method : 'GET')
      ).toUpperCase();

      return url.origin === location.origin &&
        method === 'POST' &&
        /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(
          url.pathname
        );
    } catch {
      return false;
    }
  }

  // Dawn等がfetchで行う商品追加・数量変更を検知します。
  window.fetch = async function(input, options) {
    const response = await originalFetch(input, options);

    if (response.ok && isCartMutation(input, options)) {
      // 商品追加後もカートページ側で判定する方式です。
      // 商品ページのドロワー表示だけで完結させません。
      setTimeout(navigateToCart, 150);
    }

    return response;
  };

  function init() {
    const style = document.createElement('style');

    style.textContent = `
      .tayumaz-towel-notice {
        box-sizing: border-box;
        display: flex;
        align-items: center;
        gap: 16px;
        width: 100%;
        margin: 20px 0;
        padding: 16px;
        border: 1px solid currentColor;
      }

      .tayumaz-towel-notice img {
        display: block;
        flex: 0 0 100px;
        width: 100px;
        height: 100px;
        object-fit: contain;
      }

      .tayumaz-towel-notice p {
        margin: 0;
        font-size: 14px;
        line-height: 1.8;
      }

      .tayumaz-towel-error {
        padding: 12px;
        color: #b42318;
        font-size: 14px;
      }

      @media (max-width: 749px) {
        .tayumaz-towel-notice {
          gap: 12px;
          padding: 12px;
        }

        .tayumaz-towel-notice img {
          flex-basis: 80px;
          width: 80px;
          height: 80px;
        }
      }
    `;

    document.head.append(style);
    renderNotices();
    scheduleSync();

    // セクションの差し替え後も、案内表示を復元します。
    let scheduled = false;

    const observer = new MutationObserver(() => {
      if (scheduled) return;

      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        renderNotices();
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // タオルの追加・削除処理中は通常の購入ボタン操作を待たせます。
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const checkoutButton = event.target.closest(
        '[name="checkout"], a[href$="/checkout"]'
      );

      if (checkoutButton && (busy || redirecting)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);

    document.addEventListener('submit', (event) => {
      if (
        event.submitter?.name === 'checkout' &&
        (busy || redirecting)
      ) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);

    window.addEventListener('pageshow', scheduleSync);
    window.addEventListener('focus', scheduleSync);
    document.addEventListener('shopify:section:load', renderNotices);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
